(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-product"]) return;
  try {
    
document.querySelectorAll('[data-ff-product]').forEach((root) => {
  if (root.dataset.bound === 'true') return;
  root.dataset.bound = 'true';

  const gallery = root.querySelector('[data-gallery]');
  const counter = root.querySelector('[data-counter]');
  if (gallery && counter) {
    const slides = gallery.children.length;
    const update = () => {
      const index = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
      counter.textContent = index + ' of ' + slides;
    };
    gallery.addEventListener('scroll', update, { passive: true });
  }

  const dims = root.querySelector('[data-dimensions]');
  if (dims) {
    const original = dims.textContent;
    root.querySelectorAll('[data-unit]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-unit]').forEach((item) => {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        if (button.dataset.unit === 'in') {
          dims.textContent = original.replace(/(\d+(?:[.,]\d+)?)\s*cm/gi, (_, number) => {
            const centimetres = parseFloat(number.replace(',', '.'));
            return (Math.round((centimetres / 2.54) * 10) / 10) + ' in';
          });
        } else {
          dims.textContent = original;
        }
      });
    });
  }

  const mainButton = root.querySelector('[data-main-atc]');
  const bar = root.querySelector('[data-sticky-bar]');
  const stickyAdd = root.querySelector('[data-sticky-add]');
  if (mainButton && bar && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      bar.hidden = entry.isIntersecting;
    });
    observer.observe(mainButton);
  }
  if (stickyAdd && mainButton) {
    stickyAdd.addEventListener('click', () => mainButton.click());
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
